import { GameSettingType } from "@1games-ru/region-shared/dist/enums/account/settings";
import { SoundHookReturn, SoundOptions, useSound } from "react-sounds";
import useAppSelector from "@/core/helpers/useAppSelector";
import soundtrackDict, { Soundtrack } from "@/shared/sounds";
import { appliedSoundSettingsSelector } from "@/domains/settings/sound/slice";

export default function useInterfaceSoundCore(
  soundName: Soundtrack,
  defaultOptions?: SoundOptions,
): SoundHookReturn {
  const appliedSoundSettings = useAppSelector(appliedSoundSettingsSelector);
  const soundSettings: SoundOptions = {
    volume: appliedSoundSettings
      ? appliedSoundSettings[GameSettingType.SettingInterfaceSoundsVolume] / 100
      : 0,
  };

  const props = useSound(soundtrackDict[soundName], {
    ...soundSettings,
    ...defaultOptions,
  });

  return props;
}
